import * as types from './mutations_types'

export const saveTask = (context, task) => context.commit(types.SAVE, task)

export const destroyTask = (context, id) => context.commit(types.DESTROY, id)



// WEBPACK FOOTER //
// ./src/modules/deals/components/show/tasks/store/actions.js